import CurrentToolRow from "./current-tool.row";
import "./index.styles.scss";

const CurrentToolsTable = ({ currentTools, totalCost }) => {
  const tableHeaders = [
    'Tool(s)',
    'Qty',
    'Contract End',
    'Cost',
    'Total',
  ];

  return (
    <div className="current-tools-wrapper">
      <table>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '22%' }} />
          <col style={{ width: '21%' }} />
          <col style={{ width: '17%' }} />
        </colgroup>
        <thead className="current-tools-header">
          <tr className="current-tools-header-row">
            <th colSpan={5}>Current Tools</th>
          </tr>
          <tr className="tools-header-row">
            {tableHeaders?.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentTools?.map((tool, index) => (
            <CurrentToolRow key={index} tool={tool} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td className="total-title">Total</td>
            <td className="total-cost">{totalCost}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default CurrentToolsTable;
